import _ from 'lodash';
import {
    FETCH_RAINPRO_STORAGE_ITEMS,
    CLEAN_RAINPRO_STORAGE_ITEMS,
    CHANGE_RAINPRO_STORAGE_ITEM,
    DELETE_RAINPRO_STORAGE_ITEM,
    DELETE_RAINPRO_STORAGE_ITEMS,
} from './types';
import {request, __} from '../functions';

export const fetchRainproStorageItems = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/rainpro/storage-items/${screen.props.params.id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_STORAGE_ITEMS, payload: data });
    });
};

export const cleanRainproStorageItems = () => ({ type: CLEAN_RAINPRO_STORAGE_ITEMS });

export const changeRainproStorageItem = (screen, id, sku, value, comment) => {
    return dispatch => request(`/rainpro/editStorageItem/${id}/${screen.props.params.id}`, { sku, value, comment }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť skladovú položku'));
            return;
        }

        screen.showSnackbar('success', __('Skladová položka bola zmenená'));

        dispatch({ type: CHANGE_RAINPRO_STORAGE_ITEM, payload: { id, sku, value, comment } });
    });
};

export const deleteRainproStorageItem = (screen, id) => {
    return dispatch => request(`/rainpro/removeStorageItem/${id}/${screen.props.params.id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Skladovú položku sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Skladová položka bola zmazaná'));

        dispatch({ type: DELETE_RAINPRO_STORAGE_ITEM });
    });
};

export const deleteRainproStorageItems = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/rainpro/multiDeleteStorageItems/${ids}/${screen.props.params.id}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať položky'));
            return;
        }

        screen.showSnackbar('success', __('Položky boli zmazané'));

        dispatch({ type: DELETE_RAINPRO_STORAGE_ITEMS });
    });
};
